import React, { useState } from 'react';
import ArrowDown from '../../assets/icons/common/chevron-down.svg';
import ArrowUp from '../../assets/icons/common/chevron-up-active.svg';
import { FormattedMessage } from 'react-intl';

const DropdownGroup = ({ options, value, onChange, text, selectedSitesCount, selectedSitesText}) => {
  return (
    <div className="dropdown w-100">
      <button
        type="button"
        className={`btn d-flex align-items-center bg-baby-blue h-54 justify-content-between dropdown-toggle w-100 form-control`}
        data-bs-toggle="dropdown"
        aria-expanded="false"   
        data-bs-display="static"    
        style={{ borderTopRightRadius: '0.375rem', borderBottomRightRadius: '0.375rem' ,border: '1px solid #ced4da' }}
      >
        <span style={{ flex: 1, textAlign: 'left' ,color: 'rgba(149, 149, 151, 1)'}}>
          {selectedSitesText || <FormattedMessage id={text} />}
        </span>
        <img
          src={ArrowDown}
          style={{ marginLeft: 'auto' }}
        />
      </button>
      <ul className="dropdown-menu" >
        {options}
        {/*options.map((opt) => (
          <li className="dropdown-item" key={opt.value} onClick={() => onChange(opt.value)} >
            <label className="form-check-label">{opt.label}</label>
          </li>
        ))*/}
      </ul>
    </div>
  );
};

export default DropdownGroup;